/*
  PDP gallery.

  The track is a scroll-snap row, so swipe and trackpad scrolling are native
  and need no JavaScript. This only adds what the browser does not: arrows,
  thumbnail selection, a counter, and keeping all three in agreement with
  whatever the user just did — including scrolling the track directly.

  Position is read back from scrollLeft rather than tracked in a variable,
  so a swipe, an arrow press and a thumbnail click cannot disagree.
*/
(function () {
  function init(root) {
    if (root.dataset.spGalleryReady === '1') return;
    root.dataset.spGalleryReady = '1';

    var track = root.querySelector('[data-sp-gallery-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sp-gallery-slide]'));
    if (slides.length < 2) return;

    var prev = root.querySelector('[data-sp-gallery-prev]');
    var next = root.querySelector('[data-sp-gallery-next]');
    var count = root.querySelector('[data-sp-gallery-count]');
    var scope = root.parentElement || document;
    var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-sp-gallery-thumb]'));

    function current() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }

    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }

    function sync() {
      var i = current();
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, ti) {
        var on = ti === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-sp-gallery-thumb'), 10) || 0);
      });
    });

    // Arrow keys once the track has focus.
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-sp-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init after a Section Rendering API swap.
  document.addEventListener('shopify:section:load', boot);
})();
